<template>
  <div class="flex flex-col min-h-screen bg-white transition-colors duration-300">
    <navbar-element></navbar-element>
    <router-view class="flex-grow"></router-view>
    <footer-element></footer-element>
	<kofi-widget kofi-id="facecageco"></kofi-widget>
  </div>
</template>

<script>
import NavbarElement from '@/components/NavbarElement.vue';
import FooterElement from '@/components/FooterElement.vue';
import KofiWidget from '@/components/KofiWidget.vue';
import { useAutoTracking } from '@/utils/auto-tracking';

export default {
  components: {
    NavbarElement,
    FooterElement,
	KofiWidget
  },
  setup() {
    // Initialize auto-tracking for the entire app
    useAutoTracking();
    
    return {};
  },
  // mounted() {
  //   // Remove any dark mode classes
  //   document.documentElement.classList.remove('dark');
  // }
  mounted() {
    document.title = 'FCCO - Bike Polo Livestreams, Projects & Community';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'FCCO supports the bike polo community with livestreams, 3D printed projects, and resources for players and fans worldwide.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'FCCO supports the bike polo community with livestreams, 3D printed projects, and resources for players and fans worldwide.';
      document.head.appendChild(meta);
    }
  }
}
</script>